<div class="page-layout">
  <app-toast></app-toast>

  <app-sidebar></app-sidebar>

  <div class="main-area">
    <app-navbar pageTitle="Document Access"
      pageSubtitle="View user roles and access levels for this document."></app-navbar>

    <div class="content">

      <app-pending-reviews-banner scope="document" [documentId]="docId()"></app-pending-reviews-banner>

      <!-- Breadcrumb -->
      <div class="breadcrumb-row">

        <button class="back-btn" (click)="back()">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polyline points="15 18 9 12 15 6"></polyline>
          </svg>
        </button>

        <div class="breadcrumb">
          <span class="stack-icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#8B5CF6" stroke-width="2">
              <ellipse cx="12" cy="5" rx="7" ry="3"></ellipse>
              <path d="M5 5v5c0 1.7 3.1 3 7 3s7-1.3 7-3V5"></path>
              <path d="M5 10v5c0 1.7 3.1 3 7 3s7-1.3 7-3v-5"></path>
            </svg>
          </span>

          <span>{{ docName() }}</span>

          <span class="separator">></span>
          <span class="active">
            Document Details
          </span>
        </div>

      </div>

      <!-- Table Card -->

      <div class="access-table-card">
        <ng-container *ngIf="!isLoading(); else loading">
          <ng-container *ngIf="accessRows().length; else noData">
            <table class="access-table">
              <thead>
                <tr>
                  <th style="width:26%">
                    Document
                  </th>

                  <th style="width:26%">
                    Users
                  </th>

                  <th style="width:26%">
                    Access
                  </th>

                  <th style="width:22%">
                    Evidence
                  </th>

                </tr>
              </thead>
              <tbody>

                <tr *ngFor="let row of accessRows(); let i = index">

                  <!-- DOCUMENT COLUMN -->

                  <td *ngIf="i === 0" class="document-cell" [attr.rowspan]="accessRows().length">
                    <div class="document-info">
                      <span class="file-icon" [ngClass]="getDocIconClass(docName())">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                          stroke-width="2">
                          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z">
                          </path>
                          <polyline points="14 2 14 8 20 8">
                          </polyline>
                        </svg>
                      </span>
                      <span class="document-name">
                        {{ docName() }}
                      </span>
                    </div>
                  </td>

                  <!-- USER -->

                  <td *ngIf="row.showUser" class="user-column" [attr.rowspan]="row.userRowSpan">
                    {{ row.userName }}
                  </td>

                  <!-- ACCESS -->
                  <td class="access-cell">
                    <div class="access-item">
                      {{ row.heading }}
                    </div>
                  </td>

                  <!-- EVIDENCE -->
                  <td class="evidence-cell">
                    <div class="evidence-item">
                      {{ row.evidence.join(', ') }}
                    </div>
                  </td>

                </tr>
              </tbody>
            </table>
          </ng-container>

          <ng-template #noData>
            <div class="table-empty">
              No access data available.
            </div>
          </ng-template>

        </ng-container>

        <ng-template #loading>
          <div class="table-loading">
            Loading document details...
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>